(() => {
  function bind(scope) {
    const roots = [...scope.querySelectorAll('[data-wp-fd-clean]')];
    if (scope.matches?.('[data-wp-fd-clean]')) roots.push(scope);
    roots.forEach(root => {
      if (root.dataset.wpFdBound) return;
      const dialog = root.querySelector('dialog');
      const image = dialog?.querySelector('[data-wp-fd-zoom-image]');
      const caption = dialog?.querySelector('[data-wp-fd-caption]');
      const close = dialog?.querySelector('[data-wp-fd-close]');
      if (!dialog?.showModal || !image || !caption || !close) return;
      root.dataset.wpFdBound = 'true';
      let opener;
      root.addEventListener('click', event => {
        const link = event.target.closest('[data-wp-fd-open]');
        if (!link || !root.contains(link) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const original = link.querySelector('img');
        if (!original) return;
        event.preventDefault();
        opener = link;
        image.src = link.href;
        image.alt = original.alt;
        image.width = original.naturalWidth || original.width;
        image.height = original.naturalHeight || original.height;
        caption.textContent = original.alt;
        dialog.showModal();
        close.focus({ preventScroll: true });
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { image.removeAttribute('src'); caption.textContent = ''; opener?.focus({ preventScroll: true }); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind(document), { once: true });
  else bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
